export const CONTROLLED_APP_IDS = new Set<string>([
  'blade-agent',
  'vibe-coding',
  'create-skill',
  'skills-hub',
]);

export function isControlledAppId(appId: string | undefined): boolean {
  return Boolean(appId && CONTROLLED_APP_IDS.has(appId));
}
